import { Link } from "wouter-preact";

/**
 * The disclaimer required by Legend Story Studios' Third Party Application
 * terms. The LSS wording is mandated verbatim, so do not paraphrase it.
 */
export function Disclaimer() {
  return (
    <div class="disclaimer">
      <p class="disclaimer__warning">
        FaB Judge is an AI assistant and can be wrong. For rulings in a real
        tournament, always consult a human judge.
      </p>
      <p>
        FaB Judge is in no way affiliated with Legend Story Studios. Legend
        Story Studios®, Flesh and Blood™, and set names are trademarks of Legend
        Story Studios. Flesh and Blood characters, cards, logos, and art are
        property of Legend Story Studios.
      </p>
      <p class="disclaimer__legal">
        By using FaB Judge you agree to our <Link href="/terms">Terms</Link>
        {" "}
        &amp; <Link href="/privacy">Privacy Policy</Link>.
      </p>
    </div>
  );
}
